module.exports = __webpack_public_path__ + "static/feature-egress-hinges-73218fc25b7fd65cd843e9ed9d87d760.png";